import { render } from "./PopupDisplay.vue?vue&type=template&id=2105a81b&scoped=true"
import script from "./PopupDisplay.vue?vue&type=script&lang=js"
export * from "./PopupDisplay.vue?vue&type=script&lang=js"

import "./PopupDisplay.vue?vue&type=style&index=0&id=2105a81b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2105a81b"]])

export default __exports__